import {Injectable} from '@angular/core';
import {CampaignClient, CampaignViewModel} from '../apis/api.client';
import {Disposable} from '../extensions/disposable';

@Injectable({
    providedIn: 'root'
})
export class CampaignService extends Disposable {

    private campaign: CampaignViewModel;

    constructor(
        private campaignClient: CampaignClient
    ) {
        super();
    }

    public get currentCampaignYear(): number {
        return this.campaign?.campaignYear;
    }

    public get currentCampaign(): CampaignViewModel {
        return this.campaign;
    }

    public setCurrentCampaign(campaign: CampaignViewModel): void {
        this.campaign = campaign;
    }
}
